<div class="layout-column tr flex-sm-none flex-xs-none fade-element-in-only"
     (click)="onToggle($event)"
     [ngClass]="{'selected' : isSelected}">

  <div class="flex layout-row layout-align-start-center">

    <!--Service-->
    <div class="td sticky layout-row large flex-15 text-ellipsis">
      <div *ngIf="!hideActions" class="layout-row layout-align-start-center margin-right-10">

        <!--Actions Button-->
        <app-service-action-menu flex
                                 [isDisableActionMenu]="isDisableActionMenu"
                                 [service]="service">

        </app-service-action-menu>

        <app-bringoz-checkbox [isChecked]="isSelected"
                              (clickEvent)="onToggle($event)">
        </app-bringoz-checkbox>

      </div>


      <div class="flex layout-column">
        <div class="full-width layout-row layout-align-start-center">

          <app-bringoz-status-tag [status]="service.status"
                                  [extraTooltipText]="service?.cancellationReason?.reason"
                                  [isSmall]="true"
                                  class="margin-right-5">

          </app-bringoz-status-tag>

          <bringoz-icon *ngIf="hasRevertedTask"
                        iconName="reset"
                        [appBringozTooltip]="tooltipTmpl"
                        [applyHoverColor]="true"
                        ngbTooltip
                        fill="#7E7E7E"
                        class="margin-right-5">
          </bringoz-icon>

          <ng-template #tooltipTmpl>
            <div *ngFor="let task of service.taskList" class="layout-column">
              <span *ngFor="let actionReason of task.actionReasons" class="br-body-2"
                    [appBringozTooltip]="actionReason.reason"
                    [applyHoverColor]="true"
                    ngbTooltip>
                {{ 'Revert' | translate }}: {{ actionReason.reason }}
              </span>
            </div>
          </ng-template>

          <div class="flex layout-row layout-align-start-center">
            <app-service-info-button [service]="service" class="margin-right-5"></app-service-info-button>
            <app-service-packed-indication *ngIf="service.serviceType !== 'Operation'"
                                           class="margin-right-5"
                                           [packageList]="service.packageList"
                                           [serviceType]="service.serviceType"
                                           [isPacked]="service.autoGeneratedPacked"
                                           [packingInfo]="service.packingInfo"
                                           [packedDate]="service.packedDate">

            </app-service-packed-indication>
            <app-entity-relations-indicator [service]="service"></app-entity-relations-indicator>
            <bringoz-icon *ngIf="service.routeId"
                          iconName="route"
                          fill="#A3A3A3"
                          class="margin-right-5"
                          [appBringozTooltip]="service.routeId"
                          [applyHoverColor]="true"
                          ngbTooltip
                          openDelay="300">
            </bringoz-icon>
            <app-service-agent-comment-indication *ngIf="isShowIndication"
                                                  [service]="service"
                                                  class="margin-right-5">
            </app-service-agent-comment-indication>

            <bringoz-icon *ngIf="service.risk" iconName="error-outline"
                          class="margin-right-5" fill="#E57373"></bringoz-icon>

            <app-service-spots-indication *ngIf="service.packageList"
                                          [packageList]="service.packageList"
                                          [serviceType]="service.serviceType">
            </app-service-spots-indication>

          </div>
        </div>

        <div class="margin-top-5 flex layout-row layout-align-start-center">
          <app-service-type-indication [serviceType]="service.serviceType" [isShort]="true"
                                       class="margin-right-5"></app-service-type-indication>
          <app-service-chat-button [serviceId]="service.id" class="margin-right-5"></app-service-chat-button>

          <app-service-link [serviceType]="service.serviceType"
                            [id]="service.id"
                            [externalId]="service.externalId"
                            isAllowCopyButton="true">
          </app-service-link>
        </div>
      </div>
    </div>

    <!--Order ID-->
    <div *ngIf="columns.orderId" class="flex td small layout-column layout-align-center-start">
      <app-oms-order-link *ngIf="service.omsOrderReference?.id"
                          [internalId]="service.omsOrderReference?.id"
                          [externalId]="service.omsOrderReference?.externalId">
      </app-oms-order-link>
      <span class="br-body-2" *ngIf="!service.omsOrderReference?.id">---</span>
    </div>

    <!--Route ID-->
    <div *ngIf="columns.routeId" class="flex td small layout-column">
      <span class="br-body-2">{{service.routeId}}</span>
    </div>

    <!--Display ID (Operation number)-->
    <div *ngIf="columns.displayId" class="td small flex layout-column">

      <span class="br-body-2 text-ellipsis"
            [appBringozTooltip]="service?.displayId"
            [applyHoverColor]="true"
            ngbTooltip>
        {{ service.displayId || '---' }}
      </span>
    </div>

    <!--Operational units-->
    <div *ngIf="columns.operationalUnits" class="td flex small layout-row">

      <branches-indicator *ngIf="!!service.branchReferences?.length"
                          [branches]="service.branchReferences"
                          [isShowFilterByButton]="true"
                          (filterEvent)="onFilterByType($event)"></branches-indicator>

    </div>

    <!--Agent Operational units-->
    <div *ngIf="columns.agentOperationalUnits" class="td flex small layout-row">

      <branches-indicator *ngIf="!!service.agentBranchIds?.length"
                          [branches]="service.agentBranchReferences">
      </branches-indicator>

    </div>


    <!--Items types-->
    <div class="td flex small" *ngIf="columns.itemsTypes">

      <app-packages-indicator *ngIf="service.packageList?.length && service.packageList[0].items"
                              [packages]="service.packageList[0].items"
                              [isShowFilterByButton]="true"
                              (onFilterByType)="onFilterByType($event)"
                              maxDisplay="1"></app-packages-indicator>

    </div>

    <!--Items Ids-->
    <div class="td small flex" *ngIf="columns.itemsIds">
      <ng-container *ngIf="service.packageList?.length && service.packageList[0].items">
        <app-bringoz-packages-items-display-list *ngIf="!!service"
                                                 [items]="service.packageList[0].items"
                                                 [isDisplayIds]="true"></app-bringoz-packages-items-display-list>
      </ng-container>

    </div>

    <!--Items Barcodes-->
    <div class="td small flex layout-column" *ngIf="columns.itemsBarcodes">
      <ng-container *ngIf="service?.packageList?.length && service?.packageList[0]?.itemsBarcodes">
        <app-bringoz-items-list-display [items]="service.packageList[0]?.itemsBarcodes"
                                        maxItems="1"
                                        [canCopy]="true">
        </app-bringoz-items-list-display>
      </ng-container>
    </div>

    <!--Pallets-->
    <div class="td small flex layout-column" *ngIf="columns.pallets">
      <ng-container *ngIf="service?.packageList?.length">
        <span class="br-body-2">{{service.packageList | packagePallets}}</span>
      </ng-container>
    </div>

    <!--Resource name-->
    <div class="td small flex text-ellipsis" *ngIf="columns.resource">
      <span *ngIf="service.routeReference?.resourceName"
            [appBringozTooltip]="service.routeReference?.resourceName" [applyHoverColor]="true" ngbTooltip>
        {{ service.routeReference?.resourceName }}
      </span>
    </div>

    <!--Risks-->
    <div *ngIf="columns.risks" class="td small flex layout-column">
      <div class="layout-row layout-align-start-center"
           *ngFor="let risk of service.risks">
        <span class="br-body-2 text-ellipsis"
              [appBringozTooltip]="serviceRiskTypeTooltip" [applyHoverColor]="true" ngbTooltip>
          {{ 'SERVICE_RISK_TYPES.' + risk | translate }}
          <ng-template #serviceRiskTypeTooltip>
            <span>{{ 'SERVICE_RISK_TYPES.' + risk | translate }}</span>
          </ng-template>
        </span>
      </div>
    </div>

    <!--Invoice-->
    <div *ngIf="columns.invoice" class="td flex small layout-column text-ellipsis">
      <span class="br-body-2">#{{ service.invoiceNumber || '---' }}</span>
    </div>

    <!--Account-->
    <div *ngIf="columns.account" class="td flex layout-column large">
      <app-demand-account-link [account]="service.account"
                               [isShowFilterByButton]="true"
                               [isAllowCopyButton]="true"
                               (filterEvent)="onFilterByType($event)"></app-demand-account-link>

      <app-bringoz-tags *ngIf="!!serviceTags.length" [tags]="serviceTags" maxTags="2"
                        class="margin-top-5">

      </app-bringoz-tags>
    </div>

    <!--Carrier-->
    <div *ngIf="columns.carrier" layout="column" class="td flex layout-column small text-ellipsis">

      <app-bringoz-state-link *ngIf="service.agentReference?.accountId"
                              class="flex text-ellipsis"
                              [state]="'accounts-detail-supply.info.preferences'"
                              [permission]="'accounts.supply.get'"
                              [params]="{id: service.agentReference.accountId}"
                              [text]="service.agentReference.accountName">
      </app-bringoz-state-link>

    </div>

    <!--Agent-->
    <div *ngIf="columns.agent" layout="column" class="td flex layout-column small text-ellipsis agent-column">

      <app-agent-itinerary-link [linkToAgentView]="true"
                                [agent]="service.agent"
                                [isShowCopyButton]="true"
                                [isShowFilterByButton]="true"
                                (filterEvent)="onFilterByType($event)">
      </app-agent-itinerary-link>

      <app-skill-tags [skillsIds]="service.requiredSkills" class="margin-top-5"></app-skill-tags>
    </div>

    <!--Location-->
    <div *ngIf="columns.location" class="td flex-15 large layout-column">
      <div *ngFor="let task of service.taskList"
           class="layout-row layout-align-start-center text-ellipsis">

        <app-task-purpose [purpose]="task.taskSpec?.purpose" class="margin-right-5"
                          firstLetterOnly="true"></app-task-purpose>
        <!--Task Depot-->
        <div *ngIf="task.taskSpec?.locationDetails?.locationType === locationTypes.DEPOT"
             class="layout-row layout-align-start-center text-ellipsis">
          <bringoz-icon iconName="depot" fill="#A3A3A3" class="margin-right-5"></bringoz-icon>
          <app-depot-link class="text-ellipsis"
                          [depot]="task.taskSpec.depotReference"></app-depot-link>
        </div>

        <!--Task Address-->
        <div *ngIf="task.taskSpec?.locationDetails?.locationType !== locationTypes.DEPOT"
             class="flex layout-row layout-align-start-center text-ellipsis">
          <span appBringozPpi class="text-ellipsis"
                [appBringozTooltip]="locationTooltip" [applyHoverColor]="true" ngbTooltip>
            {{ task.taskSpec.address | bringozAddress }}</span>
          <app-address-quality class="flex-5"
                               [address]="task.taskSpec?.address">
          </app-address-quality>
        </div>

      </div>

      <ng-template #locationTooltip>
        <div class="layout-column layout-align-start-center">
          <div *ngFor="let task of service.taskList" class="layout-row layout-align-start-center margin-bottom-10">
            <app-task-purpose [purpose]="task.taskSpec?.purpose" class="margin-right-5"
                              firstLetterOnly="true"></app-task-purpose>
            <div class="layout-column layout-align-start-center">
              <span class="br-body-2">{{ 'Address' | translate }}: {{ task.taskSpec.address | bringozAddress }}</span>
              <div layout="row" layout-align="start center">
                <span class="br-body-2 margin-right-10">{{ 'Floor' | translate }}
                  : {{ task.taskSpec.address.floor || '--' }}</span>
                <span class="br-body-2">{{ 'Apt' | translate }}: {{ task.taskSpec.address.apartment || '--' }}</span>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </div>

    <!--Task Approval Status-->
    <div *ngIf="columns.taskApprovalStatus" class="td flex layout-column small text-ellipsis">
      <span class="br-body-2">{{ service.taskList[0]?.taskApprovalInfo?.approvalVehicleLicensePlanteNumber }}</span>
      <div *ngFor="let task of service.taskList">
        <span class="br-body-2">
          {{ task.taskApprovalInfo?.taskApprovalStatus ? ('TASK_APPROVAL_STATUS.' + task.taskApprovalInfo?.taskApprovalStatus | translate) : '---' }}
        </span>
      </div>
    </div>

    <!--Progress-->
    <div *ngIf="columns.progress" class="td flex-10 small text-ellipsis">

      <app-service-progress-bar ng-if="$ctrl.service.serviceProgress"
                                [id]="service.id"
                                [progress]="service.serviceProgress"
                                [serviceType]="service.serviceType">
      </app-service-progress-bar>
    </div>

    <!--Contact-->
    <div *ngIf="columns.contact" layout="column" class="td flex layout-column small text-ellipsis">
      <div *ngFor="let task of service.taskList">
        <div appBringozPpi class="font-weight-400 text-ellipsis"
             [appBringozTooltip]="contactTooltip" [applyHoverColor]="true" ngbTooltip>
          <span appBringozPpi>{{ task.taskSpec?.contact?.businessName }}</span>
          <span *ngIf="task.taskSpec?.contact?.businessName && task.taskSpec?.contact?.name">/</span>
          <span appBringozPpi>{{ task.taskSpec?.contact?.name }}</span>

          <ng-template #contactTooltip>
            <div class="layout-column">
              <div layout="row" layout-align="start center" class="layout-row layout-align-start-center">
                <bringoz-icon iconName="contact-circle" fill="#D2D2D2" class="margin-right-5"></bringoz-icon>
                <span appBringozPpi class="br-body-2">{{ task.taskSpec.contact.businessName }}</span>
                <span ng-if="task.taskSpec?.contact?.businessName && task.taskSpec?.contact?.name"
                      class="br-body-2 margin-left-5 margin-right-5">/</span>
                <span appBringozPpi class="br-body-2">{{ task.taskSpec.contact.name }}</span>
              </div>
              <div class="layout-row layout-align-start-center">
                <bringoz-icon iconName="phone" fill="#D2D2D2" class="margin-right-5"></bringoz-icon>
                <div class="layout-column">
                  <span appBringozPpi class="br-body-2">{{ task.taskSpec?.contact?.phoneNo | bringozPhone }}</span>
                  <span ng-if="task.taskSpec?.contact?.additionalPhoneNo"
                        appBringozPpi
                        class="br-body-2">{{ task.taskSpec?.contact?.additionalPhoneNo | bringozPhone }}</span>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <!--Program Type-->
    <div *ngIf="columns.programType" class="td flex layout-column small">
      <span class="text-ellipsis">{{ service.pricePlanName ? (service.pricePlanName) : '---' }}</span>
    </div>

    <!--Assigned Date-->
    <div *ngIf="columns.assignedDate" class="td flex layout-column small text-ellipsis">
      <span *ngIf="service.status !== serviceStatusType.Unassigned"
            class="text-ellipsis">{{ service | bringozDate: 'assignedDate':true }}</span>
    </div>

    <!--ETAs-->
    <div *ngIf="columns.eta" class="td flex layout-column small text-ellipsis">
      <div *ngIf="service.status ==='Completed'" class="layout-column layout-align-center-start">
            <span class="br-body-1 text-ellipsis"
                  [appBringozTooltip]="statusUpdatedAtTooltip" [applyHoverColor]="true"
                  ngbTooltip>{{ 'Completed' | translate }}:
              <ng-template #statusUpdatedAtTooltip>
                  <div>
                    <span class="br-body-1">{{ 'Completed' | translate }}:</span>
                    <span class="br-body-1">{{ service | bringozTime: 'statusUpdatedAt' }}</span>
                  </div>
              </ng-template>
            </span>
        <div layout="row" class="layout-row layout-align-start-center">
          <span>{{ service | bringozTime: 'statusUpdatedAt' }}</span>

          <app-bringoz-eta-tooltip [eta]="service.statusUpdatedAt"
                                   [timeZoneId]="service.taskList[0].taskSpec.address.zoneIdName"
                                   [configZoneId]="configZoneId"></app-bringoz-eta-tooltip>
        </div>
      </div>

      <ng-container *ngIf="service.status !== 'Completed'">
        <app-task-eta *ngFor="let task of service.taskList"
                      [task]="task"
                      [configZoneId]="configZoneId"
                      [timeZoneId]="task.taskSpec.address.zoneIdName">

        </app-task-eta>
      </ng-container>


    </div>

    <!--Distance-->
    <div *ngIf="columns.distance" class="td flex layout-column small text-ellipsis">
      <span>{{ service.distance | bringozDistance: '---' }} {{ siteDistanceLargeUnit | translate }}</span>
    </div>

    <!--Service Areas-->
    <div *ngIf="columns.serviceAreas" class="td flex layout-column small text-ellipsis">
      <app-service-service-areas-indication class="flex"
                                            maxItems="3"
                                            [service]="service"></app-service-service-areas-indication>
    </div>

    <!--Time Window-->
    <div *ngIf="columns.timeWindow" class="td flex-15 layout-column large">
      <div *ngFor="let task of service.taskList"
           class="layout-row layout-align-start-center">
        <div class="layout-row layout-align-start-center text-ellipsis">

          <div *ngIf="service.urgency" class="margin-0 margin-right-5 urgency" [ngClass]="service.urgency"
               [appBringozTooltip]="service.urgency | translate" [applyHoverColor]="true" ngbTooltip></div>

          <span class="br-body-2 text-ellipsis"
                [appBringozTooltip]="task.taskSpec | timeWindow" [applyHoverColor]="true" ngbTooltip>
            {{ task.taskSpec | timeWindow }}
          </span>
        </div>

        <app-bringoz-time-window-tooltip class="flex-10"
                                         [isTooltip]="true"
                                         [notBefore]="task.taskSpec.notBefore"
                                         [notAfter]="task.taskSpec.notAfter"
                                         [timeZoneId]="task.taskSpec.address.zoneIdName"
                                         [configZoneId]="configZoneId">
        </app-bringoz-time-window-tooltip>

      </div>
    </div>

    <!--Urgency-->
    <div *ngIf="columns.urgency" class="td flex-5 layout-column small">
      <span class="br-body-2 urgency-color font-weight-600"
            [ngClass]="service.urgency">
        {{ service.urgency | translate }}
      </span>
    </div>

    <!--Load-->
    <div *ngIf="hasFleetManagementPermission && columns.load"
         class="td flex layout-column small text-ellipsis">
      <div class="layout-row layout-align-start-center">
        <ng-container *ngIf="service.packageList?.length && service.packageList[0].items">
          <bringoz-icon iconName="weight" fill="#A3A3A3"></bringoz-icon>
          <app-service-package-weight class="text-ellipsis"
                                      *ngIf="service.packageList.length && service.packageList[0]?.items"
                                      [items]="service.packageList[0].items">

          </app-service-package-weight>
        </ng-container>

      </div>
      <div class="layout-row layout-align-start-center">
        <ng-container *ngIf="service.packageList?.length && service.packageList[0].items">
          <bringoz-icon iconName="volume" fill="#A3A3A3"></bringoz-icon>
          <app-service-package-volume *ngIf="service.packageList.length && service.packageList[0]?.items"
                                      class="text-ellipsis"
                                      [items]="service.packageList[0].items"></app-service-package-volume>
        </ng-container>
      </div>
    </div>

    <!--Price-->
    <div *ngIf="hasPricePlanPermission && columns.price" class="td flex small text-ellipsis">
      <app-service-price-dialog class="flex" [service]="service"></app-service-price-dialog>
    </div>

    <!--Time To Pickup-->
    <div *ngIf="columns.timeToPickup" class="td flex small text-ellipsis">
      <app-bringoz-countdown-service-adapter
        *ngIf="service.status !== 'Completed' && service.status !== 'Canceled' && service.status !== 'ManualHandled'"
        [from]="service.notBefore"
        [to]="service.notAfter"
        [keepCountWhenNegative]="true"
        [countToStart]="true">
      </app-bringoz-countdown-service-adapter>


      <app-bringoz-countdown-service-adapter
        *ngIf="service.status === 'Completed' && service.status === 'Canceled' && service.status === 'ManualHandled'"
        [from]="service.notBefore"
        [to]="service.notAfter"
        [statusUpdatedAt]="service.statusUpdatedAt"
        [keepCountWhenNegative]="true"
        [stopCount]="true">
      </app-bringoz-countdown-service-adapter>

      <span
        *ngIf="service.status === 'Completed' || service.status === 'Canceled' || service.status === 'ManualHandled'">
        {{ service.statusUpdatedAt | bringozTimeAgo }}
      </span>

    </div>

    <!--Time To Deliver-->
    <div *ngIf="columns.timeToDeliver" class="td flex small text-ellipsis">

      <app-bringoz-countdown-service-adapter
        *ngIf="service.status !== 'Completed' && service.status !== 'Canceled' && service.status !== 'ManualHandled'"
        [from]="service.notBefore"
        [to]="service.notAfter"
        [countToDate]="service.notAfter"
        [keepCountWhenNegative]="true"
        [countToStart]="true">
      </app-bringoz-countdown-service-adapter>

      <app-bringoz-countdown-service-adapter
        *ngIf="service.status === 'Completed' && service.status === 'Canceled' && service.status === 'ManualHandled'"
        [from]="service.notBefore"
        [to]="service.notAfter"
        [countToDate]="service.notAfter"
        [statusUpdatedAt]="service.statusUpdatedAt"
        [keepCountWhenNegative]="true"
        [stopCount]="true">
      </app-bringoz-countdown-service-adapter>

      <span
        *ngIf="service.status === 'Completed' || service.status === 'Canceled' || service.status === 'ManualHandled'">
        {{ service.statusUpdatedAt | bringozTimeAgo }}
      </span>

    </div>

    <!--Since Created-->
    <div *ngIf="columns.created" class="td flex small text-ellipsis">
      <span class="br-body-2"
            [appBringozTooltip]="service.createdAt | bringozTimeAgo" [applyHoverColor]="true" ngbTooltip>
        {{ service.createdAt | bringozTimeAgo }}
      </span>
    </div>

    <!--Action Reasons-->
    <div *ngIf="columns.actionReason" class="td layout-column flex small text-ellipsis">

      <!--Cancellation Reason-->
      <span *ngIf="!!service.cancellationReason" class="br-body-2"
            [appBringozTooltip]="service.cancellationReason?.reason"
            [applyHoverColor]="true" ngbTooltip>
        {{ 'Cancellation' | translate }}: {{ service.cancellationReason?.reason }}
      </span>

      <!--Edit Time Window Reason-->
      <span *ngIf="!!service.actionReasonInfo?.editTimeWindowReason" class="br-body-2"
            [appBringozTooltip]="service.actionReasonInfo.editTimeWindowReason?.reason"
            [applyHoverColor]="true" ngbTooltip>
        {{ service.actionReasonInfo.editTimeWindowReason?.reason }}
      </span>

      <!--Tasks Reasons-->
      <div class="layout-column">
        <div *ngFor="let task of service.taskList" class="layout-column">
          <app-bringoz-items-list-display [items]="reasons"
                                          [maxItems]="2">

          </app-bringoz-items-list-display>
        </div>
      </div>

    </div>

    <!--PRO Number-->
    <div *ngIf="columns.proNumber" class="td flex layout-row small text-ellipsis"
         (mouseenter)="canCopyProNumber=true"
         (mouseleave)="canCopyProNumber=false">

      <span *ngIf="service.proNumber" class="br-body-2"
            [appBringozTooltip]="service.proNumber" [applyHoverColor]="true" ngbTooltip>
        {{ service.proNumber || '-&#45;&#45;' }}</span>
      <app-text-copy-button *ngIf="canCopyProNumber && !!service.proNumber" [text]="service.proNumber"
                            [isShowCopyBtn]="canCopyProNumber"></app-text-copy-button>

    </div>

    <!--Reference Ids-->
    <div class="td flex small" *ngIf="columns.referenceIds">
      <ng-container *ngIf="service.referenceIds">
        <app-bringoz-items-list-display [items]="service.referenceIds"
                                        maxItems="1">
        </app-bringoz-items-list-display>
      </ng-container>
    </div>

    <!--Logistics Vehicles-->
    <div class="td flex-10 medium"
         *ngIf="columns.logisticsVehicles && hasFleetManagementPermission">
      <div *ngFor="let task of service.taskList"
           class="layout-row layout-align-start-center text-ellipsis gap-5">

        <app-task-purpose [purpose]="task.taskSpec?.purpose"
                          firstLetterOnly="true">

        </app-task-purpose>

        <div class="layout-row flex" *ngIf="enableAgentVehicleBinding">
          <app-logistics-vehicle-link
            *ngIf="!!task.analysis?.mainLogisticsVehicleReference; else elseNoMainLogisticsVehicle"
            class="flex br-body-2 text-ellipsis"
            [id]="task.analysis.mainLogisticsVehicleReference.id"
            [name]="task.analysis.mainLogisticsVehicleReference.name">
          </app-logistics-vehicle-link>

          <ng-template #elseNoMainLogisticsVehicle>
            <span class="br-body-2">---</span>
          </ng-template>

          <app-logistics-vehicle-link *ngIf="!!task.analysis?.attachedLogisticsVehicleReferences?.length"
                                      class="flex br-body-2 text-ellipsis"
                                      [id]="task.analysis.attachedLogisticsVehicleReferences[0].id"
                                      [name]="task.analysis.attachedLogisticsVehicleReferences[0].name">
          </app-logistics-vehicle-link>
        </div>

        <div class="layout-row flex" *ngIf="!enableAgentVehicleBinding">
          <app-logistics-vehicle-link
            *ngIf="!!task.serviceInfo?.mainLogisticsVehicleReference; else elseNoMainLogisticsVehicle"
            class="flex br-body-2 text-ellipsis"
            [id]="task.serviceInfo.mainLogisticsVehicleReference.id"
            [name]="task.serviceInfo.mainLogisticsVehicleReference.name">
          </app-logistics-vehicle-link>

          <ng-template #elseNoMainLogisticsVehicle>
            <span class="br-body-2">---</span>
          </ng-template>

          <app-logistics-vehicle-link *ngIf="!!task.serviceInfo?.attachedLogisticsVehicleReferences?.length"
                                      class="flex br-body-2 text-ellipsis"
                                      [id]="task.serviceInfo.attachedLogisticsVehicleReferences[0].id"
                                      [name]="task.serviceInfo.attachedLogisticsVehicleReferences[0].name">
          </app-logistics-vehicle-link>
        </div>

      </div>
    </div>

    <!--Notes-->
    <div class="td flex-10 large padding-0" *ngIf="columns.notes">

      <div *ngIf="!!service.notes?.length" class="layout-column notes-container">
        <div class="layout-column"
             *ngFor="let note of service.notes; let first = first"
             [ngClass]="{'margin-top-5': !first}">
          <div class="layout-row layout-align-start-center">
            <span *ngIf="note.title" class="br-body-2 font-weight-600">{{ note.title }}</span>
            <span *ngIf="note.noteType === 'CANCELLATION_REASON' && note.title"
                  class="br-body-2 font-weight-600 margin-left-10">
            {{ 'Cancellation Reason' | translate }}:
          </span>
          </div>

          <div *ngIf="note.text" class="layout-row layout-align-start-center">
            <span class="br-body-2 desc-txt">{{ note.text }}</span>
          </div>
        </div>
      </div>

    </div>

    <!--Special Instructions-->
    <div class="td flex large layout-column" *ngIf="columns.specialInstructions">
      <div *ngFor="let specialInstruction of serviceTasksSpecialInstructions"
           class="layout-row layout-align-start-center text-ellipsis"
           [appBringozTooltip]="specialInstruction.instruction" [applyHoverColor]="true" ngbTooltip>
        <app-task-purpose [purpose]="specialInstruction.purpose"
                          [firstLetterOnly]="true">
        </app-task-purpose>
        <span class="flex text-ellipsis margin-left-5">{{ specialInstruction.instruction }}</span>
      </div>
    </div>

    <!--POD's-->
    <div class="td flex large layout-column" *ngIf="columns.pods">
      <app-service-task-pods [service]="service"></app-service-task-pods>
    </div>

    <!--Dynamic Columns-->
    <div class="td flex layout-row small text-ellipsis"
         *ngFor="let metaData of dynamicColumns">
      <span class="br-body-2 text-ellipsis">{{ service.metaData | bringozMetaDataDisplay: metaData }}</span>
    </div>

    <!--Packages Dynamic Columns-->
    <div layout="row" class="td flex layout-row small text-ellipsis"
         *ngFor="let packageDynamicColumn of packageDynamicColumns">
      <ng-container *ngIf="service.packageList?.length && service.packageList[0].items">
     <span class="br-body-2 text-ellipsis">
              {{ service.packageList[0].items | bringozCustomDataDisplay: packageDynamicColumn }}
      </span>
      </ng-container>
    </div>

  </div>

</div>
